import { useEffect, useState } from 'react';

import { Editor } from '@tiptap/core';
import { NodeSelection } from '@tiptap/pm/state';

export const useCardFocusTracking = (
  editor: Editor,
  getPos: () => number | undefined,
  nodeSize: number,
) => {
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    const handleSelectionUpdate = () => {
      const pos = getPos();
      if (typeof pos !== 'number') return;
      const { selection } = editor.state;
      const from = selection.from;
      const nodeEnd = pos + nodeSize;
      const isInsideContent = from > pos && from < nodeEnd;
      const isNodeSelected = selection instanceof NodeSelection && from === pos;
      setIsFocused(isInsideContent || isNodeSelected);
    };
    editor.on('selectionUpdate', handleSelectionUpdate);
    return () => {
      editor.off('selectionUpdate', handleSelectionUpdate);
    };
  }, [editor, getPos, nodeSize]);

  return isFocused;
};
